import React from 'react'
import { Box, HStack, Image, Text, useColorModeValue } from '@chakra-ui/react'

const Skillgrid = ({ image, name }) => {
  return (
    <HStack
      boxShadow='lg'
      box-shadow={' rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'}
      p='6'
      rounded='lg'
      bg={useColorModeValue('"whiteAlpha.900"', '#86469C')}
      border="2px solid #FFDC7F"
      _hover={{
        boxShadow: 'xl',
        bg: '#78B7D0',
        color: '#16325B' ,
        transform: 'scale(1.05)',
        transition: 'all 0.3s ease',
      }}
      cursor="pointer" // Add a pointer cursor on hover
    >
      <Image src={image} height={10} width={10} />
      <Text >{name}</Text>
    </HStack>
  )
}

export default Skillgrid
